const ua = navigator.userAgent
//判断当前环境是否是 图书app 环境
console.log(ua)
export const isXesBook = ua.indexOf('xes-book') > -1
